import ConfirmationModal from './ConfirmationModal';
export { ButtonType } from '../../common/buttons/CustomButton';
export default ConfirmationModal;
